<template>
  <v-card :class="kpiClass" :to="to" @click.stop="kpiClick">
    <v-flex v-if="icon">
      <v-container>
        <v-layout row wrap>
          <v-flex v-if="icon" xs2>
            <slot name="icon">
              <v-avatar class="beez-padding" tile :icon="icon">
                <v-icon
                  :size="size"
                  :small="small"
                  :medium="medium"
                  :large="large"
                  :x-large="xLarge"
                  >{{ icon }}
                </v-icon>
              </v-avatar>
            </slot>
          </v-flex>
          <v-flex v-else>
            <div
              style="margin-right: 20px; height: 90%; width: 5px;"
              :class="kpiClass"
            ></div>
          </v-flex>
          <v-flex xs10>
            <div class="text-xs-right">
              <slot name="heading" :heading="heading">
                <div class="headline">{{ heading }}</div>
              </slot>
              <slot name="sub-heading" :sub-heading="subHeading">
                <v-tooltip bottom>
                  <div slot="activator" class="body-1 text-truncate">
                    {{ subHeading }}
                  </div>
                  <span>{{ subHeading }}</span>
                </v-tooltip>
              </slot>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-flex v-else class="pa-3">
      <v-layout row wrap>
        <v-flex xs12>
          <div class="text-xs-right">
            <slot name="heading" :heading="heading">
              <div class="headline">{{ heading }}</div>
            </slot>
            <slot name="sub-heading" :sub-heading="subHeading">
              <v-tooltip bottom>
                <div slot="activator" class="body-1 text-truncate">
                  {{ subHeading }}
                </div>
                <span>{{ subHeading }}</span>
              </v-tooltip>
            </slot>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  name: 'KpiCard',
  props: {
    icon: String,
    heading: String | Number,
    subHeading: String | Number,
    small: Boolean,
    medium: Boolean,
    large: Boolean,
    xLarge: Boolean,
    size: String | Number,
    to: Object
  },
  computed: {
    kpiClass() {
      return 'metric--card-' + ((Math.floor(Math.random() * 10) + 1) % 9)
    }
  },
  methods: {
    kpiClick() {
      this.$emit('kpi-click')
    }
  }
}
</script>

<style scoped>
.metric--card-0 {
  background-image: linear-gradient(135deg, #ee9ae5 10%, #5961f9 100%);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
  border-radius: 5px;
}

.metric--card-1 {
  background-image: linear-gradient(135deg, #36d1dc 10%, #5b86e5 100%);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
  border-radius: 5px;
}

.metric--card-2 {
  background-image: linear-gradient(135deg, #a8e063 10%, #56ab2f 100%);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
  border-radius: 5px;
}

.metric--card-3 {
  background-image: linear-gradient(135deg, #667eea 10%, #764ba2 100%);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
  border-radius: 5px;
}

.metric--card-4 {
  background-image: linear-gradient(135deg, #48c6ef 10%, #6f86d6 100%);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
  border-radius: 5px;
}

.metric--card-5 {
  background-image: linear-gradient(135deg, #80d0c7 10%, #13547a 100%);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
  border-radius: 5px;
}

.metric--card-6 {
  background-image: linear-gradient(135deg, #00cdac 10%, #02aab0 100%);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
  border-radius: 5px;
}

.metric--card-7 {
  background-image: linear-gradient(135deg, #868f96 10%, #596164 100%);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
  border-radius: 5px;
}

.metric--card-8 {
  background-image: linear-gradient(135deg, #06beb6 10%, #48b1bf 100%);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
  border-radius: 5px;
}
</style>
